import Skeleton from "react-loading-skeleton";
import { twMerge } from "tailwind-merge";

import { Avatar as avatarImage } from "~/common/assets";
import { Avatar, Typography } from "~/common/components";
import { getFullName } from "~/providers/utils";
import { useGetCurrentPatient } from "../hooks";
import { isPatientInScreeningStatus } from "../utils";

interface CurrentTeamMemberProps {
  className?: string;
}

export const CurrentProvider = ({ className }: CurrentTeamMemberProps) => {
  const { data: patient, isLoading } = useGetCurrentPatient();

  const primaryProvider = patient?.organization_patients[0].primary_provider;

  const isScreeningPatient = isPatientInScreeningStatus(patient);

  return (
    <div
      className={twMerge(
        "flex w-full items-center justify-end gap-2",
        className,
      )}
    >
      {isLoading ? (
        <Skeleton
          containerClassName="flex items-center justify-center"
          className="block animate-pulse self-center bg-neutral-400"
          width={100}
          height={16}
          count={1}
        />
      ) : (
        <div className="truncate text-end">
          {!isScreeningPatient && (
            <Typography className="truncate font-semibold text-gray-35">
              {getFullName(primaryProvider?.name, primaryProvider?.last_name)}
            </Typography>
          )}
          <Typography className="truncate text-gray-35">
            {patient?.organization_patients[0].organization.name}
          </Typography>
        </div>
      )}

      <Avatar
        className="size-11 rounded-full"
        alt="profilePicture"
        src={primaryProvider?.profile_picture_path ?? avatarImage}
      />
    </div>
  );
};
